/*
 * App Constants and Actions
 *
 */

export const setGlobalLoader = (payload) => ({
  type: 'SHOW_GLOBAL_LOADER',
  payload,
});

export const setPageLoader = (payload) => ({
  type: 'SET_PAGE_LOADER',
  payload,
});
